import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {DnbUsageStatus} from '../../models/dnb-usage.model';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root',
})
export class DnbService {
  private apiService = inject(ApiService);

  getUsageStatus(clientId: string): Observable<DnbUsageStatus> {
    return this.apiService.get<DnbUsageStatus>('hubspot/dnb-usage', {clientId});
  }
}
